import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col
} from 'reactstrap';
import { toast } from 'react-hot-toast';

class CommitEditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      commit_mid: props.commit?.commit_mid || '',
      version: props.commit?.version || '',
      friendly_version: props.commit?.friendly_version || '',
      status: props.commit?.status || 'draft',
      title: props.commit?.title || '',
      main_message_ids: props.commit?.main_message_ids?.join('\n') || '',
      sub_message_ids: props.commit?.sub_message_ids?.join('\n') || '',
      main_doc_ids: props.commit?.main_doc_ids?.join('\n') || '',
      sub_doc_ids: props.commit?.sub_doc_ids?.join('\n') || '',
      created_by: props.commit?.created_by || '',
      metadata: props.commit?.metadata ? JSON.stringify(props.commit.metadata, null, 2) : '{}',
      branch_id: props.commit?.branch_id || '',
      parent_branch_id: props.commit?.parent_branch_id || '',
      children_branch_ids: props.commit?.children_branch_ids?.join('\n') || '',
      type: props.commit?.type || 'commit',
      commit_message: props.commit?.commit_message || '',
      checkpoint_data: {
        tests: props.commit?.checkpoint_data?.tests || '',
        answers: props.commit?.checkpoint_data?.answers || '',
        profile_ai: props.commit?.checkpoint_data?.profile_ai || '',
        profile_user: props.commit?.checkpoint_data?.profile_user || '',
        content: props.commit?.checkpoint_data?.content || ''
      }
    };
  }

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name.startsWith('checkpoint_data.')) {
      const field = name.split('.')[1];
      this.setState(prevState => ({
        checkpoint_data: {
          ...prevState.checkpoint_data,
          [field]: value
        }
      }));
    } else {
      this.setState({
        [name]: type === 'checkbox' ? checked : value
      });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    try {
      const formData = {
        ...this.state,
        _id: this.props.commit._id,
        metadata: JSON.parse(this.state.metadata),
        main_message_ids: this.state.main_message_ids.split('\n').filter(Boolean),
        sub_message_ids: this.state.sub_message_ids.split('\n').filter(Boolean),
        main_doc_ids: this.state.main_doc_ids.split('\n').filter(Boolean),
        sub_doc_ids: this.state.sub_doc_ids.split('\n').filter(Boolean),
        children_branch_ids: this.state.children_branch_ids.split('\n').filter(Boolean)
      };
      this.props.onSubmit(formData);
    } catch (error) {
      console.error('Invalid JSON in metadata:', error);
      toast.error('Invalid JSON format in metadata');
    }
  };

  handleDelete = async () => {
    if (!this.props.commit._id) return;
    
    if (window.confirm('Are you sure you want to delete this commit? This action cannot be undone.')) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/k3commit/${this.props.commit._id}`, {
          method: 'DELETE'
        });
        
        if (!response.ok) {
          throw new Error('Failed to delete commit');
        }
        
        toast.success('Commit deleted successfully');
        this.props.toggle();
        window.location.href = '/v1/commit';
      } catch (error) {
        console.error('Error deleting commit:', error);
        toast.error('Failed to delete commit');
      }
    }
  };

  render() {
    const { isOpen, toggle } = this.props;
    const { 
      commit_mid, version, friendly_version, status, title,
      main_message_ids, sub_message_ids, main_doc_ids, sub_doc_ids,
      created_by, metadata, branch_id, parent_branch_id,
      children_branch_ids, type, commit_message, checkpoint_data
    } = this.state;

    return (
      <Modal isOpen={isOpen} toggle={toggle} size="xl">
        <ModalHeader toggle={toggle}>Edit Commit</ModalHeader>
        <ModalBody>
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <Col md="4">
                <FormGroup>
                  <Label>Commit MID</Label>
                  <Input
                    type="text"
                    name="commit_mid"
                    value={commit_mid}
                    onChange={this.handleChange}
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Version</Label>
                  <Input
                    type="text"
                    name="version"
                    value={version}
                    readOnly
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Friendly Version</Label>
                  <Input
                    type="text"
                    name="friendly_version"
                    value={friendly_version}
                    onChange={this.handleChange}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="4">
                <FormGroup>
                  <Label>Status</Label>
                  <Input
                    type="select"
                    name="status"
                    value={status}
                    onChange={this.handleChange}
                  >
                    <option value="draft">Draft</option>
                    <option value="final">Final</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Type</Label>
                  <Input
                    type="select"
                    name="type"
                    value={type}
                    onChange={this.handleChange}
                  >
                    <option value="commit">Commit</option>
                    <option value="checkpoint">Checkpoint</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Created By</Label>
                  <Input
                    type="text"
                    name="created_by"
                    value={created_by}
                    onChange={this.handleChange}
                    readOnly
                  />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label>Title</Label>
              <Input
                type="text"
                name="title"
                value={title}
                onChange={this.handleChange}
                required
              />
            </FormGroup>

            <FormGroup>
              <Label>Commit Message</Label>
              <Input
                type="textarea"
                name="commit_message"
                value={commit_message}
                onChange={this.handleChange}
                rows={4}
                required
              />
            </FormGroup>

            <Row>
              <Col md="6">
                <FormGroup>
                  <Label>Main Message IDs (one per line)</Label>
                  <Input
                    type="textarea"
                    name="main_message_ids"
                    value={main_message_ids}
                    onChange={this.handleChange}
                    rows={3}
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label>Sub Message IDs (one per line)</Label>
                  <Input
                    type="textarea"
                    name="sub_message_ids"
                    value={sub_message_ids}
                    onChange={this.handleChange}
                    rows={3}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <FormGroup>
                  <Label>Main Doc IDs (one per line)</Label>
                  <Input
                    type="textarea"
                    name="main_doc_ids"
                    value={main_doc_ids}
                    onChange={this.handleChange}
                    rows={3}
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label>Sub Doc IDs (one per line)</Label>
                  <Input
                    type="textarea"
                    name="sub_doc_ids"
                    value={sub_doc_ids}
                    onChange={this.handleChange}
                    rows={3}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="4">
                <FormGroup>
                  <Label>Branch ID</Label>
                  <Input
                    type="text"
                    name="branch_id"
                    value={branch_id}
                    onChange={this.handleChange}
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Parent Branch ID</Label>
                  <Input
                    type="text"
                    name="parent_branch_id"
                    value={parent_branch_id}
                    onChange={this.handleChange}
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Children Branch IDs (one per line)</Label>
                  <Input
                    type="textarea"
                    name="children_branch_ids"
                    value={children_branch_ids}
                    onChange={this.handleChange}
                    rows={3}
                  />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label>Metadata (JSON)</Label>
              <Input
                type="textarea"
                name="metadata"
                value={metadata}
                onChange={this.handleChange}
                rows={4}
              />
            </FormGroup>

            {type === 'checkpoint' && (
              <div className="checkpoint-data">
                <h5>Checkpoint Data</h5>
                <FormGroup>
                  <Label>Tests</Label>
                  <Input
                    type="textarea"
                    name="checkpoint_data.tests"
                    value={checkpoint_data.tests}
                    onChange={this.handleChange}
                    rows={3}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Answers</Label>
                  <Input
                    type="textarea"
                    name="checkpoint_data.answers"
                    value={checkpoint_data.answers}
                    onChange={this.handleChange}
                    rows={3}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Profile AI</Label>
                  <Input
                    type="textarea"
                    name="checkpoint_data.profile_ai"
                    value={checkpoint_data.profile_ai}
                    onChange={this.handleChange}
                    rows={3}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Profile User</Label>
                  <Input
                    type="textarea"
                    name="checkpoint_data.profile_user"
                    value={checkpoint_data.profile_user}
                    onChange={this.handleChange}
                    rows={3}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Content</Label>
                  <Input
                    type="textarea"
                    name="checkpoint_data.content"
                    value={checkpoint_data.content}
                    onChange={this.handleChange}
                    rows={3}
                  />
                </FormGroup>
              </div>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={this.handleDelete}>Delete</Button>
          <Button color="secondary" onClick={toggle}>Cancel</Button>
          <Button color="primary" onClick={this.handleSubmit}>Save Changes</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default CommitEditModal; 